const GformUpload = () => {

    // Add a filter to Gravity Forms file upload fields in order to change the 
    // appearance of the delete button
    gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl) {
        
        // Fetch the form ID and field ID for the upload field currently in view
        var formId = up.settings.multipart_params.form_id,
        fieldId = up.settings.multipart_params.field_id;
        
        // Amend our HTML - also see "adpt_change_upload_markup()" in custom-functions.php
        // as both versions of override need to be applied! https://docs.gravityforms.com/gform_file_upload_markup/
        return "<span class='gform_file_name'>" + file.name + "</span><span class='gform_file_delete' onclick='gformDeleteUploadedFile(" + formId + ", " + fieldId + ", this);'>remove</span>";
        
    });
}

export default GformUpload;